/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lg_Guest_Guide_TitleInputs */

const en_lg_guest_guide_title = /** @type {(inputs: Lg_Guest_Guide_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welcoming guests to one room`)
};

const id_lg_guest_guide_title = /** @type {(inputs: Lg_Guest_Guide_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menerima tamu di satu ruang`)
};

/**
* | output |
* | --- |
* | "Welcoming guests to one room" |
*
* @param {Lg_Guest_Guide_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const lg_guest_guide_title = /** @type {((inputs?: Lg_Guest_Guide_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lg_Guest_Guide_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_lg_guest_guide_title(inputs)
	return en_lg_guest_guide_title(inputs)
});